module.exports = __webpack_public_path__ + "media/images/logo_sm-335a4bad1e26bb925e2d136572d62a63.png";